import { render, staticRenderFns } from "./PlaceListSection.vue?vue&type=template&id=6e609c9e&scoped=true"
import script from "./PlaceListSection.vue?vue&type=script&lang=ts"
export * from "./PlaceListSection.vue?vue&type=script&lang=ts"
import style0 from "./PlaceListSection.vue?vue&type=style&index=0&id=6e609c9e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e609c9e",
  null
  
)

export default component.exports